exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".center tr th {\n  text-align: center;\n}\n.center tr td {\n  text-align: center;\n}\n.warning-user-img {\n  width: 100px;\n  height: 100px;\n  object-fit: contain;\n  border-radius: 4px;\n  margin-right: 10px;\n  border: 1px solid #e5e5e5;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/evs/logs/tab2/error-stamp-scanning.component.css
// module id = ../../../../../src/app/pages/admin/evs/logs/tab2/error-stamp-scanning.component.css
// module chunks = 3